<div class="px-3 py-2">
	<h4 align="center">LA DE CIFRIS INCONTRA SALERNO</h4>
	<p>Il giorno <b>9 maggio 2018</b> si è tenuta una nuova sessione a Salerno 
		della costituenda associazione nazionale di crittografia De Componendis Cifris.
	</p>
	<p>Questa sessione è la prima delle tre sessioni territoriali del 2018.</p>
	<p><b>Luogo: Università degli Studi di Salerno, Campus di Fisciano - Aula P1, Edificio F3</b></p>
	<p>L'incontro si propone di offrire una panoramica sulle attività di ricerca in Campania, 
		riguardanti la Crittografia e le sue applicazioni. Con l'occasione si presenta l'iniziativa 
		Nazionale "De Componendis Cifris" che organizza l'evento.</p>
	<p>L'iniziativa De Cifris di aggregazione delle competenze di Crittografia vuole stimolare 
		la collaborazione in ambito crittografico, coinvolgendo sia le numerose eccellenze 
		accademiche, che sono tuttora presenti in Italia, sia il mondo delle Aziende che operano nel settore.
	</p>
	<p><a href="../../../../assets/eventi/2018/Salerno/locandina_May2018.pdf">Locandina</a></p>
	<h5>PROGRAMMA</h5>
	<ul>
		<li>
			<p><b>10:00-11:50 Sessione I - Prof. G. Persiano</b></p>
			<ul class="ulSon">
				<li>
					<p>10.00 Prof. Aurelio Tommasetti<br>
						<i style="color: green;">Magnifico Rettore</i><br>
						Università di Salerno</p>
				</li>
				<li>
					<p>10.10 Prof. Massimiliano Sala<br>
						<i style="color: green;">Acting Director</i> <br>
						De Componendis Cifris <br>
						<a href="../../../../assets/eventi/2018/Salerno/DeCifris_May2018.pdf">Slide</a>
					</p>
				</li>
				<li>
					<p>10.30 Prof. Roberto Baldoni<br>
						<i style="color: green;">Vice Direttore Generale</i> <br>
						Dip. delle Informazioni per la Sicurezza <br>
    					Presidenza del Consiglio dei Ministri
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>10:50-11:15 Coffe Break</b></p></li>
		<li>
			<p><b>11:15-12:45 Sessione II - Prof.ssa O. Polverino</b></p>
			<ul class="ulSon">
				<li>
					<p>11.15 Ing. P. Malato Vice Presidente Sez. ICT<br>
						<i>Unione Industriali Napoli</i>
					</p>
				</li>
				<li>
					<p>11.30 Dott. Carlo Solimene<br>
						<i>Direttore Divisione Polizia Postale e delle Comunicazioni</i>
					</p>
				</li>
				<li>
					<p>11:45 Prof. A. De Santis DI, Univ. di Salerno <br> 
						Panoramica sulle attività in ambito crittografico del Dipartimento di Informatica
					</p>
				</li>
				<li>
					<p>12.00 Prof. G. Persiano <br> 
						DISA-MIS, Univ. di Salerno <br>
						<i>Selezione di Dati Rilevanti da uno Stream Cifrato</i>
					</p>
				</li>
				<li>
					<p>12.15 Prof. I. Visconti – DIEM, Univ. di Salerno<br> 
						<i>Advanced Cryptography for Blockchain Technology</i>
					</p>
				</li>
				<li>
					<p>12.30 Prof.ssa M. Tota – DM, Univ. di Salerno<br> 
						<i>A Mathematical Look at (the) PRESENT</i>
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>12:45-14:00 Lunch break</b></p></li>
		<li><p><b>14:00-15:00 Sessione III - Prof. G. Lunardon</b></p>
			<ul class="ulSon">
				<li>
					<p>14.00 Ing. M. Ciampi/Prof. G. Schmid – ICAR/CNR <br>
						<i>A Matter of Trust</i>
					</p>
				</li>
				<li>
					<p>14.15 Prof. C. Galdi – DIETI, Univ. di Napoli Federico II<br>
						Enterprise Right Management Systems in Dispositivi Mobili
					</p></li>
				<li>
					<p>14.30 Ing. C. Moretti – MBDA Italia S.p.A.<br>
						Scenari Operativi e Security Requirements per un'Azienda del Comparto Difesa
					</p>
				</li>
				<li>
					<p>14.45 Ing. L. Castaldo – Bit4id s.r.l.<br>
						<i>Identità Digitale, Privacy e Blockchain</i>
					</p>
				</li>
			</ul>
		</li>
		<li><p>15:00-15:30 Coffe Break</p></li>
		<li><p><b>15:30-16:30 Sessione IV - Prof. A. Tortora</b></p>
			<ul class="ulSon">
				<li>
					<p>15.30 Dott. E. Casati – InfoCert S.p.A. <br>
						<i>Identità digitale: decentralizzazione e zero knowledge 
							nel nuovo paradigma della Self Sovereign Identity</i>
					</p>
				</li>
				<li>
					<p>15.45 Ing. D. Cappetta – Eustema S.p.A. <br>
						<i>La Blockchain per la Notarizzazione di Processi Documentali	</i>
					</p></li>
				<li>
					<p>16:00 Dott. A. Beccari- Domp Farmaceutici S.p.A. <br>
						<i>The Evolution of Open Innovation in Pharma Sector: The Cyber Security Perspectives</i>
					</p>
				</li>
				<li>
					<p>16.15 Ing. N. Fedele – Bluenet s.r.l. <br>
						<i>Metterci la faccia ovvero un selfie per battere i bagarini online	</i>
					</p>
				</li>
			</ul>
		</li>
		<li><p>16:30-17:00 Questions & Answers/Closing Remarks/Networking</p></li>
	</ul>
	<hr>
	<p>Si ringrazia l'Associazione Algebr&#64;Salerno per il supporto.</p>
	<p>Eventuali richieste possono essere inviate a: segreteria&#64;decifris.it</p>
	<p>Questo evento è stato coordinato a livello nazionale dall'Acting Director della De 
		Componendis Cifris e a livello locale dal Comitato De Cifris, che contiene esponenti 
		di tutte le realtà di ricerca (con sedi in Campania) interessate alle attività dell'iniziativa</p>
		<p>Il Comitato De Cifris è rappresentato da:</p>
		<p>
			Prof. Tortora Antonio (Chair) - <b>Università degli Studi di Salerno</b> - Dipartimento di Matematica; <br>
			Prof. Persiano Giuseppe - <b>Università degli Studi di Salerno</b> - Dipartimento di Scienze Aziendali - Management & Innovation Systems (DISA); <br>
			Prof. Visconti Ivan - <b>Università degli Studi di Salerno</b> - Dipartimento di Ingegneria dell'Informazione ed Elettrica e Matematica Applicata (DIEM);<br>
			Prof. Schmid Giovanni - <b>Consiglio Nazionale delle Ricerche (CNR)</b> - Istituto di Calcolo e Reti ad Alte Prestazioni (ICAR);<br>
			Prof. Galdi Clemente - <b>Università degli Studi di Napoli "Federico II"</b> - Dipartimento di Ingegneria Elettrica e Tecnologie dell'Informazione (DIETI);<br>
			Prof. Lunardon Guglielmo - <b>Università degli Studi di Napoli "Federico II"</b> - Dipartimento di Matematica e Applicazioni (MAT);<br>
			Prof.ssa Polverino Olga - <b>Università degli Studi della Campania "Luigi Vanvitelli"</b> - Dipartimento di Matematica e Fisica (DMF).
		</p>
</div>
  